var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgHouseRed = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 66,
  height: 67,
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M20.261 51.896V40.75h8.968v11.145a2.242 2.242 0 0 0 2.242 2.229h6.725a2.242 2.242 0 0 0 2.242-2.23V36.293h3.81c1.032 0 1.525-1.27.74-1.939L26.248 17.568a2.269 2.269 0 0 0-3.004 0L4.501 34.353c-.762.669-.291 1.94.74 1.94h3.811v15.603a2.242 2.242 0 0 0 2.242 2.229h6.726a2.242 2.242 0 0 0 2.241-2.23Z",
  fill: "#0564AA"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  d: "M41.25 8.75v3.3h16.5v-3.3h-16.5Zm0 6.6v3.3h16.5v-3.3h-16.5Zm0 6.6v3.3h16.5v-3.3h-16.5Z",
  fill: "#0564AA"
})));
export default SvgHouseRed;